import React, { FunctionComponent, useEffect, useState } from 'react';
import { Button, TextArea, Icon, Modal, Loader, Checkbox } from '@scuf/common';
import {  ERROR_MSG_FOR_USER_RESPONSE,  HAS_SCRIPT,  AUDIT_REJECT_NOTE, OPPORTUNITY_STATUS, EMPTY_NOTES_TEXT,  AUDIT_RESPONSE_STATUS,  AUDIT_REJECT_REASON,  COMMENT_TYPE,  USER_ROLE} from '../../../constants/constants';
import { useAppDispatch } from '../../../store';
import { useSelector } from 'react-redux';
import { toast, ToastContent, Zoom } from 'react-toastify';
import { Snackbar } from '../../Snackbar/Snackbar';
import { getReviewActivityLog, updateAuditOpportunity } from '../../../services/UserAction';
import { IAuditResponseModel } from '../../../models/IOpportunitiesAPIModel';
import moment from 'moment';
import { IFeedbackAPIModel } from '../../../models/IFeedbackAPIModel';
import { getActiveDashboardTab } from '../../../slices/userProfileSlice';
import { getallSamplingOpportunities, setPaginationCurrentPage } from '../../../slices/samplingSlice';
import { setPaginationCurrentPage as setAnomaliyCurrentPage } from "../../../slices/allOpportunitySlice";
import { DASHBOARD_TABS } from '../../../constants/constants';
import { getallOpportunities, setLastPageBeforeLandingDetailedPage, getStatusPills } from '../../../slices/allOpportunitySlice';
import { useNavigate } from 'react-router-dom';
import { RouteConstants } from '../../../constants/constants';
import addNotesIcon from '../../../images/add-notes.png';
import "../NewCardDesign/CommonStyle.scss";
import './AuditReject.scss';
import { getMessage } from 'src/message/utils';
import DOMPurify from 'dompurify';

interface IAcceptPopup {
  onClose: Function;
  kpiId: number;
  title: string;
  textAreaTitle: string;
  opportunityId: any;
  sendUserResponse?: Function;
  anomaly_id: number;
  insightStatus?: string;
  orgUserId?: string;
  reviewerId?: string;
  auditType?: string;
  auditSubmitDisable?: boolean;
  sendingMailToatser?: Function;
  role_name?: string;
}
type ToastType =
  | 'audit-reject' | 'audit-accept' | 'business-accept' | 'business-reject';

export const AuditReject: FunctionComponent<IAcceptPopup> = (props) => {
  const [enableRetryErr, setEnableRetryErr] = useState(false); // flag to enable submit button
  const [acceptActionInProgress, setacceptActionInProgress] = useState(false);
  const [btnText, setBtnText] = useState('Submit');
  const [comments, setComments] = useState('');
  const dispatch = useAppDispatch();
  const [showRemarkError, setShowRemarkError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageFlag, setErrorMessageFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [auditLog, setAuditLog] = useState([]);
  const [reasons, setReasons] = useState({ reason1: false, reason2: false, reason3: false });
  const activeDashboardTab = useSelector(getActiveDashboardTab);
  const navigate = useNavigate();
  const auditRejectNote = getMessage('app.anomalydetails.rightsection.auditrejnote');
  const hasScript = getMessage('app.anomalydetails.rightsection.specialcharscondition');
  const warningText = getMessage('app.notes.footer.warning');

  const showActionToast = (toastContent: ToastContent, type: ToastType) => {
    if (type === AUDIT_RESPONSE_STATUS.REJECT || type === AUDIT_RESPONSE_STATUS.BUSINESS_REJECT) {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
    else if (type === AUDIT_RESPONSE_STATUS.ACCEPT || type === AUDIT_RESPONSE_STATUS.BUSINESS_ACCEPT) {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };
  const handleCommentsOnChange = (e: string) => {
    setComments(e);
  };

  const handleDisable = () => {
    let resultDisabled = true;
    if (props.role_name === USER_ROLE.POWER_USER || props.role_name === USER_ROLE.DOMAIN_FOCAL) {
      if ((props.auditType === 'audit-accept' || props.auditType === 'business-accept') && props.auditSubmitDisable === false) {
        resultDisabled = false;
      }
      else if ((props.auditType === 'audit-reject' || props.auditType === 'business-reject') && (((reasons.reason1 || reasons.reason2) && reasons.reason3 === false) || ((reasons.reason1 || reasons.reason2) && (reasons.reason3 === true && comments.trim().length > 0)) || (reasons.reason3 === true && comments.trim().length > 0)) && props.auditSubmitDisable === false) {
        resultDisabled = false;
      } else {
        resultDisabled = true;
      }
    }
    return resultDisabled;
  }

  const handleAudit = () => {
    setacceptActionInProgress(true);
    let inValidCharacter = /[<>()&#]/;
    let reasonBody: IFeedbackAPIModel = {} as IFeedbackAPIModel;
    let result: number[] = [];
    Object.values(reasons).forEach((item, index) => item ? result.push(index) : null);
    reasonBody.reason = result.length > 0 ? result.map((value: number) => AUDIT_REJECT_REASON[value]).join(',') : '';
    let data: IAuditResponseModel = {
      audit_response: props.auditType,
      remarks: comments,
      reasons: reasonBody.reason,
      mail_sendto_id: null
    };
    if (props.role_name === USER_ROLE.POWER_USER || props.role_name === USER_ROLE.DOMAIN_FOCAL) {
      if ((props.insightStatus === OPPORTUNITY_STATUS.ACCEPTED) || (props.insightStatus === OPPORTUNITY_STATUS.REJECTED)) {
        data = {
          audit_response: props.auditType,
          remarks: comments,
          reasons: reasonBody.reason,
          mail_sendto_id: props.reviewerId
        };
      }
      if ((props.insightStatus === OPPORTUNITY_STATUS.ACCEPTED_ORGUSER) || (props.insightStatus === OPPORTUNITY_STATUS.REJECTED_ORGUSER)) {
        data = {
          audit_response: props.auditType,
          remarks: comments,
          reasons: reasonBody.reason,
          mail_sendto_id: props.orgUserId
        };
      }
    }


    if (!inValidCharacter.test(comments)) {
      dispatch(updateAuditOpportunity(props.opportunityId, data))
        .then((response: any) => {
      
          if (props.auditType === 'audit-accept') {
            showActionToast(
              <Snackbar toastMessage="Audit Accepted Successfully" />,
              'audit-accept'
            );
          }
          if (props.auditType === 'audit-reject') {
            showActionToast(
              <Snackbar toastMessage="Audit Rejected Successfully" />,
              'audit-reject'
            );
          }

          if (props.auditType === 'business-accept') {
            showActionToast(
              <Snackbar toastMessage="Business Accepted Successfully" />,
              'business-accept'
            );
          }
          if (props.auditType === 'business-reject') {
            showActionToast(
              <Snackbar toastMessage="Business Rejected Successfully" />,
              'business-reject'
            );
          }
            
          if (activeDashboardTab === DASHBOARD_TABS.SAMPlEPAGE) {
            dispatch(setPaginationCurrentPage(1));
            dispatch(getallSamplingOpportunities());
            dispatch(setLastPageBeforeLandingDetailedPage(1));
            navigate(RouteConstants.SAMPLE_ABSOLUTE_PATH);
          }
          else {
            dispatch(setAnomaliyCurrentPage(1));
            dispatch(getallOpportunities());
            dispatch(getStatusPills());
            dispatch(setLastPageBeforeLandingDetailedPage(1));
            navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH);
          }
        })
        .catch((error: any) => {
          if (error) {
            setErrorMessage(error.response.data.message);
          }
          else { setErrorMessage(ERROR_MSG_FOR_USER_RESPONSE); }
          setErrorMessageFlag(true);
          setEnableRetryErr(true);
          setacceptActionInProgress(false);
          setBtnText('Retry');
        });
    } else {
      setShowRemarkError(true);
      setacceptActionInProgress(false);
    }

  };

  useEffect(() => {
    const logData: any = {
      include_type: [
        'business-action', 'audit-action'
      ],
      'insight_id': `${props.opportunityId}`
    };
    setLoader(true);
    dispatch(getReviewActivityLog(logData)).then((response: any) => {
      setAuditLog(response?.activity);
      setLoader(false);
    }).catch((err: any) => {
      console.log('audit error', err);
      setError(true);
    });
  }, [dispatch, props.opportunityId]);

  return (
    <>
      {/* <Modal.Header >{props.title} </Modal.Header> */}
      <Modal.Content className="audit-content">
        <div className="comment_note">{auditRejectNote}</div>
        {showRemarkError && (
          <div className="accept-popup__remarkerr">{hasScript}</div>
        )}
        <TextArea
          onChange={handleCommentsOnChange}
          className="textarea-wrapper input-label-message textarea-fi"
          fluid={true}
          rows={2}
          indicator={reasons.reason3 ? 'required' : undefined}
          placeholder={props.textAreaTitle}
          label="Comments"
          value={comments}
          required={true}
        />
        <div className='email-error mt-3' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(warningText,{
                ALLOWED_ATTR:['href', 'target']
            }) }}></div>
        <div className="audit-reject__wrapper" style={{ display: (props.auditType === AUDIT_RESPONSE_STATUS.REJECT || props.auditType === AUDIT_RESPONSE_STATUS.BUSINESS_REJECT) ? 'block' : 'none' }}>
          <h4>Reasons</h4>
          <Checkbox label="Comments are not clear" checked={reasons.reason1} className="checkbox-fi" onChange={(checked: boolean) => setReasons({ ...reasons, reason1: checked })} />
          <Checkbox label="Disagree with anomaly dispositioning" checked={reasons.reason2} className="checkbox-fi" onChange={(checked: boolean) => setReasons({ ...reasons, reason2: checked })} />
          <Checkbox label="Others" checked={reasons.reason3} className="checkbox-fi" onChange={(checked: boolean) => setReasons({ ...reasons, reason3: checked })} />
        </div>
        <div
          style={{ position: 'relative' }}
          data-testid="getInvoiceCard"
        >
          {loader && (
            <Loader
              loading={loader}
              text="Fetching activity log..."
              minHeight="28vh"
              max-height="70vh"
              overlayColor="transparent"
            />
          )
          }
          {
            error && (
              <div className="notes-error-text">
                {ERROR_MSG_FOR_USER_RESPONSE}
              </div>
            )
          }
          {auditLog && auditLog.length > 0 ? (<div >
            <div className="timeline-wrapper">
              {
                auditLog && auditLog.length > 0 && auditLog.map((item: any) => (
                  <div className="notes-node" key={item.created_on}>
                    <div className="notes-node_date">
                      {moment(item.created_on).format(
                        ' Do MMMM Y, dddd, h:mm A'
                      )}
                    </div>
                    <div className="notes-node_name">
                      <span className="type-comment">
                        {item.last_name + ', ' + item.first_name}
                      </span>
                      &nbsp;
                    </div>
                    {
                      item && item.audit_details && item.audit_details.audit_response.includes("audit-accept") ? "accepted" : item.audit_details?.audit_response.includes("audit-reject") ? "rejected" : null
                    }  {COMMENT_TYPE.AUDIT}
                    {
                      item && item.audit_details && item.audit_details.audit_response.includes("business-accept") ? "accepted(business)" : item.audit_details?.audit_response.includes("business-reject") ? "rejected(business)" : null
                    }  {COMMENT_TYPE.AUDIT}
                    <>{item && item.audit_details && item.audit_details.remarks && <div className="notes-node_comment">Remarks-{item.audit_details.remarks.toLowerCase()}</div>}</>
                    <>{item && item.audit_details && item.audit_details.reasons && <div className="notes-node_comment">Reasons-{item.audit_details.reasons.toLowerCase()}</div>}</>


                  </div>
                ))
              }
            </div>
          </div>) :
            (
              <div className="empty-notes">
                <img src={addNotesIcon} alt="empty log" />
                <div className="empty-notes--description_empty">
                  {EMPTY_NOTES_TEXT}
                </div>
              </div>
            )
          }
        </div>
      </Modal.Content>
      <Modal.Footer className='pop-footer'>
        {errorMessageFlag && errorMessage.length > 0 && (
          <div className="getMorePopup__footer--err">{errorMessage}</div>
        )}
        <Button
          className="button--secondary button-space"
          data-testid="cancel"
          size="small"
          type="secondary"
          disabled={acceptActionInProgress}
          onClick={() => {
            props.onClose();
          }}
          content="Cancel"
        />
        <Button
          className={`button-space button--primary ${acceptActionInProgress
              ? 'getMorePopup__footer--readonly btn-loading'
              : ''
            }`}
          icon={
            enableRetryErr ? (
              <Icon
                root="building"
                name="refresh"
                exactSize={22}
                className="getMorePopup__footer--retry"
              />
            ) : (
              ''
            )
          }
          iconPosition="right"
          size="small"
          disabled={handleDisable()}
          type="primary"
          data-testid="submit"
          onClick={handleAudit}
          content={btnText}
        />
      </Modal.Footer>
    </>
  );
};
